import { FeatureFlagEnum } from "@pharaday/feature-flag";

import { ToolTypeEnum } from "../core/domain/enums/tool-type.enum";

export const getToolFeatureFlag = (type: ToolTypeEnum): FeatureFlagEnum | undefined => {
  if (type === ToolTypeEnum.COLLABORATIVE_CONTAINER) {
    return FeatureFlagEnum.COLLABORATION_APP;
  }

  return undefined;
};
